module.exports = __webpack_public_path__ + "static/media/netflix-logo.a1f673e7.png";